@if (payments && mode !== Mode.ZERO) {
  <div class="re-mb-default">
    <div class="bigger bold re-mb-default" data-qa="forderung" [ngClass]="mode === Mode.CREDIT ? 'good' : 'error'">
      {{payments?.offeneSumme | cutMinus | currency:'EUR'}}
    </div>
    @if (bankAccountAssignments && bankAccountAssignments[mode]) {
      <div data-qa="with-sepa">
        <div data-qa="sepa-text">{{config[mode].sepaText}}</div>
        @if (bankAccountAssignments && bankAccountAssignments[mode]) {
          <div data-qa="assignment">{{bankAccountAssignments[mode].bankname}}:&nbsp;{{bankAccountAssignments[mode].iban}}</div>
        }
      </div>
    } @else {
      <div class="re-mb-default" data-qa="without-sepa">{{config[mode].withoutSepa}}</div>
      <div class="re-mb-default" data-qa="sepa-hint">{{config[mode].withBankAccounts}}</div>
    }
  </div>
}
